/** Marks a record id the client assigned to a row the server has not created yet. */
export const NEW_RECORD_ID_PREFIX = "new-";
